import { z } from 'zod'

export const trialCodeInfoSchema = z.object({
  duration: z.number().int(),
  quota: z.number().int(),
  status: z.enum(['active', 'completed', 'inactive', 'upcoming']),
  redirect_link: z.string(),
})
export type TrialCodeInfo = z.infer<typeof trialCodeInfoSchema>
